import { Validation } from "@vuelidate/core";
import { Ref } from "vue";

export function resetVuelidateErrors(validation: Ref<Validation>): void {
  setTimeout(() => {
    validation.value.$reset();
  });
}
